import React, {useState, useEffect} from 'react';
import {TextOutline} from '../TextOutline/TextOutline'

import {runQuery} from '../utils'
import {getMembersOf} from './queries'


interface MyComponentProps {
    /** 
    * resource id of focused passage, e.g. paragraph or div structure
    */
    focusedResourceid?: string,
    /**
    * resource id of current section
    */
    resourceid: string,
    /**
    * title of current section
    */
    title?: string,
    /**
    * hide entire outline
    */
    hidden?: boolean,
    /**
    * manifestation and transcription slug
    * used to create links in outline to specific manifestation
    * or transcription
    */
    /**
    * indications whether a link at the collection level should be set or not
    */
    collectionLink?: boolean,
    showFirstLevelChildren?: boolean,
    focusResourceid?: string,
    mtFocus?: string,
    showAuthor?: boolean,
    author?: string,
    authorTitle?: string,
    showParentLink?: boolean
    handleChangeInfo?: any
}


export const TextOutlineWrapper: React.FC<MyComponentProps> = (props) => {
  const [membersOf, setMembersOf] = useState<any[]>([])
  
  useEffect(() => {
    if (props.focusResourceid){
      retrieveMembersOf(props.focusResourceid);
    }
  }, [props.resourceid, props.focusResourceid])

  const retrieveMembersOf = (id: string) => {
       const membersOfInfo = runQuery(getMembersOf(id))
        membersOfInfo.then((data) => {
          const newData = data.data.results.bindings.map((d:any) => {
            return d.memberOf.value
          })
          setMembersOf(newData)
        })
      }


      return (
              <div className={props.hidden ? "hidden" : "showing"}>
                <TextOutline
                  key={props.resourceid}
                  showChildren={true}
                  showFirstLevelChildren={props.showFirstLevelChildren}
                  focusResourceid={props.focusResourceid}
                  resourceid={props.resourceid}
                  title={props.title}
                  level={"1"}
                  structureType={"http://scta.info/resource/structureCollection"}
                  membersOf={membersOf}
                  mtFocus={props.mtFocus}
                  collectionLink={props.collectionLink}
                  showAuthor={props.showAuthor}
                  showParentLink={props.showParentLink}
                  handleChangeInfo={props.handleChangeInfo}
                  />
              </div>
            );

}



// class TextOutlineWrapper extends React.Component {
//   constructor(props){
//     super(props)
//     mounted = ""
//     state = {
//       membersOf: [],
//     }
//   }
//   retrieveMembersOf(resourceid){
//     const membersOfInfo = runQuery(getMembersOf(resourceid))
//     membersOfInfo.then((data) => {
//       const newData = data.data.results.bindings.map((d) => {
//         return d.memberOf.value
//       })
//       if (mounted){
//         setState({membersOf: newData})
//       }
//     })
//   }
//   componentDidMount(){
//     mounted = true;
//     retrieveMembersOf(props.focusResourceid)
//   }
//   componentDidUpdate(prevProps){
//     if (props.focusResourceid !== prevProps.focusResourceid){
//       retrieveMembersOf(props.focusResourceid)
//     }
//   }
//   componentWillUnmount(){
//     mounted = false;
// }
//   render(){
//     return (
//       <div className={props.hidden ? "hidden" : "showing"}>

//         <TextOutline
//           key={props.resourceid}
//           showChildren={true}
//           showFirstLevelChildren={props.showFirstLevelChildren}
//           focusResourceid={props.focusResourceid}
//           resourceid={props.resourceid}
//           title={props.title}
//           level={"1"}
//           structureType={"http://scta.info/resource/structureCollection"}
//           membersOf={state.membersOf}
//           mtFocus={props.mtFocus}
//           collectionLink={props.collectionLink}
//           showAuthor={props.showAuthor}
//           showParentLink={props.showParentLink}
//           />
//       </div>
//     );
//   }
// }

// TextOutlineWrapper.propTypes = {
//   /**
//   * resource id of focused passage, e.g. paragraph or div structure
//   */
//   focusedResourceid: PropTypes.string,
//   /**
//   * resource id of current section
//   */
//   resourceid: PropTypes.string,
//   /**
//   * title of current section
//   */
//   title: PropTypes.string,
//   /**
//   * hide entire outline
//   */
//   hidden: PropTypes.bool,
//   /**
//   * manifestation and transcription slug
//   * used to create links in outline to specific manifestation
//   * or transcription
//   */
//   mtFoucs: PropTypes.string,
//   /**
//   * indications whether a link at the collection level should be set or not
//   */
//   collectionLink: PropTypes.bool
// }
// export default TextOutlineWrapper;
